<template>
  <!-- eslint-disable max-len -->
  <svg
    :style="`height: ${height}px; width: ${width}px;`"
    viewBox="0 0 51 51"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    class="not-sr-only"
  >
    <g
      fill="none"
      fill-rule="evenodd"
    >
      <g transform="translate(-427 -677)">
        <g transform="translate(406 656)">
          <g transform="translate(10 10)">
            <path
              transform="translate(36.5 36.5) rotate(67) translate(-36.5 -36.5)"
              d="m36.5 10.624l18.297 7.579 7.579 18.297-7.579 18.297-18.297 7.579-18.297-7.579-7.579-18.297 7.579-18.297 18.297-7.579z"
              stroke="#336"
              stroke-width="3"
            />
            <g transform="translate(24 21)">
              <g transform="translate(5)">
                <mask fill="white">
                  <use xlink:href="#path-1" />
                </mask>
                <path
                  d="m0.0037588 13.387c3.9216e-5 -0.28589 0.20955-0.53231 0.50098-0.58915 0.74153-0.14457 1.1243-0.66497 1.4508-1.3636 1.0161-2.1745 2.9454-3.9943 4.9343-5.3669 1.6623-1.1472 2.079-2.2289 2.158-3.9638 0.045902-1.0088 0.21322-1.8091 1.389-2.035 1.1779-0.22631 1.7171 0.27019 2.1548 1.4786 0.64643 1.7847 0.29863 3.0236-0.52375 4.6866-0.41888 0.84699-0.83273 1.6991-1.1859 2.5725-0.19963 0.49365-0.13749 0.69386-0.045039 0.84893 0.27243 0.45691 1.1114 0.34184 3.2233 0.29183 1.8369-0.043508 2.4574 0.012781 3.1041 0.1292 1.5197 0.27362 1.9436 0.6999 2.0549 0.82062 0.43325 0.46988 0.64016 1.1332 0.60525 1.9753-0.024784 0.59863-0.43682 1.1824-0.71394 1.8783 1.2597 1.9325 1.2287 2.5735-0.43282 3.8789 1.0936 1.4424 0.81363 2.6483-0.66647 3.6995-0.14135 0.10036-0.21769 0.34927-0.23539 0.53695-0.21765 2.3065-0.90416 2.759-3.4524 2.9489-4.8052 0.13013-4.8052 0.25907-11.442-0.40309-0.6121-0.061096-1.596-0.16276-2.2257-0.22813-0.3419-0.035477-0.60331-0.30925-0.61075-0.63978-0.014843-0.65761-0.036686-1.7203-0.038235-2.3371-0.0073137-2.9246-0.0034314-5.8492-0.0029608-8.8197"
                  fill="#336"
                  mask="url(#mask-2)"
                />
              </g>
              <path
                d="m3.5329 26h-3.0658c-0.25797 0-0.46709-0.25782-0.46709-0.57585v-11.848c0-0.31804 0.20912-0.57583 0.46709-0.57583h3.0658c0.25797 0 0.46711 0.2578 0.46711 0.57583v11.848c0 0.31804-0.20914 0.57585-0.46711 0.57585"
                fill="#336"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'SvgThumbsUp',
  props: {
    height: {
      type: Number,
      default: 64,
    },
    width: {
      type: Number,
      default: 64,
    },
  },
};
</script>
